
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1obZq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "CommentRepliesOld", () => $ed2abbb22349fd1a$export$b8b4e9ab3bc04aea);
$parcel$export(module.exports, "CommentRepliesNew", () => $ed2abbb22349fd1a$export$d3607a444dfdab77);
$parcel$export(module.exports, "default", () => $ed2abbb22349fd1a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ahm5r = parcelRequire("ahm5r");

var $12DRg = parcelRequire("12DRg");

var $dyOHn = parcelRequire("dyOHn");

var $4DuXn = parcelRequire("4DuXn");

var $lStFm = parcelRequire("lStFm");

var $9c4a4 = parcelRequire("9c4a4");

var $gCeeo = parcelRequire("gCeeo");

var $gqt7O = parcelRequire("gqt7O");

var $6d9QY = parcelRequire("6d9QY");

var $l5RKy = parcelRequire("l5RKy");

var $bJscI = parcelRequire("bJscI");

var $epTsa = parcelRequire("epTsa");

var $4smaW = parcelRequire("4smaW");

var $7YBvC = parcelRequire("7YBvC");

var $1xPp6 = parcelRequire("1xPp6");

var $h4uO8 = parcelRequire("h4uO8");
const $ed2abbb22349fd1a$var$memoizedReplies = (0, $ahm5r.createSelector)((commentId, state)=>(0, $4DuXn.commentRepliesSelector)(commentId)(state), (result)=>result);
const $ed2abbb22349fd1a$var$memoizedRepliesWithCollapseState = (0, $ahm5r.createSelector)((commentId, state)=>(0, $4DuXn.commentRepliesWithCollapseStateSelector)(commentId)(state), (result)=>result);
const $ed2abbb22349fd1a$var$memoizedCommentCollapseInfoSelector = (0, $ahm5r.createSelector)((commentId, state)=>(0, $4DuXn.commentCollapseInfoSelector)(commentId)(state), (result)=>result);
const $ed2abbb22349fd1a$var$memoizedPagesInfo = (0, $ahm5r.createSelector)((commentId, state)=>(0, $4DuXn.childCommentsPageInfoSelector)(commentId)(state), (result)=>result);
const $ed2abbb22349fd1a$var$memoizedReplyEditor = (0, $ahm5r.createSelector)((commentId, state)=>(0, $4DuXn.isReplyingToCommentSelector)(commentId)(state), (result)=>result);
// Memoized permalink status to avoid recalculation
const $ed2abbb22349fd1a$var$getMemoizedPermalinkStatus = ()=>(0, $9c4a4.getPermalinkStatus)((0, $lStFm.COMMENTS));
const $ed2abbb22349fd1a$export$b8b4e9ab3bc04aea = (props)=>{
    const { fullIssueUrl: fullIssueUrl, commentSessionId: commentSessionId, commentId: commentId } = props;
    const dispatch = (0, $dyOHn.useDispatch)();
    const isReplyingToComment = (0, $dyOHn.useSelector)((state)=>$ed2abbb22349fd1a$var$memoizedReplyEditor(commentId, state));
    const replies = (0, $dyOHn.useSelector)((state)=>$ed2abbb22349fd1a$var$memoizedReplies(commentId, state));
    const childCommentsPageInfo = (0, $dyOHn.useSelector)((state)=>$ed2abbb22349fd1a$var$memoizedPagesInfo(commentId, state));
    const loadingStage = (0, $dyOHn.useSelector)((state)=>(0, $4DuXn.loadingStageSelector)(state));
    const getMoreOlderComments = (0, $eJOHy.useCallback)(()=>{
        dispatch((0, $gqt7O.fetchOlderChildCommentsRequest)(commentId));
    }, [
        dispatch,
        commentId
    ]);
    const getMoreNewerComments = (0, $eJOHy.useCallback)(()=>{
        dispatch((0, $gqt7O.fetchNewerChildCommentsRequest)(commentId));
    }, [
        dispatch,
        commentId
    ]);
    const previousRepliesLength = (0, $6d9QY.usePrevious)(replies?.length);
    (0, $eJOHy.useEffect)(()=>{
        if (childCommentsPageInfo) {
            const repliesLength = replies?.length;
            if (previousRepliesLength !== repliesLength && (!replies || repliesLength === 0)) {
                if (childCommentsPageInfo.hasNextPage) getMoreOlderComments();
                else if (childCommentsPageInfo.hasPreviousPage) getMoreNewerComments();
            }
        }
    }, [
        replies,
        childCommentsPageInfo,
        previousRepliesLength,
        getMoreNewerComments,
        getMoreOlderComments
    ]);
    if (!replies || replies.length === 0) return null;
    const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $9c4a4.getPermalinkStatus)((0, $lStFm.COMMENTS));
    const showOlderComments = (analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'showMoreReplies', {
            olderComments: true
        });
        getMoreOlderComments();
    };
    const showNewerComments = (analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'showMoreReplies', {
            newerComments: true
        });
        getMoreNewerComments();
    };
    const hasReplies = replies && replies.length > 0;
    const isNewChildCommentSaving = loadingStage === `${0, $l5RKy.SAVE_CHILD_COMMENT_LOADING_PREFIX}${commentId}`;
    const isLatestChildCommentNotVisible = childCommentsPageInfo?.hasPreviousPage;
    if (isNewChildCommentSaving && isLatestChildCommentNotVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xPp6.default), {
        onClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        commentId: commentId,
        type: (0, $l5RKy.ActionButton).PREVIOUS,
        forceShowLoadingState: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, childCommentsPageInfo?.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xPp6.default), {
        onClickHandler: showOlderComments,
        commentId: commentId,
        type: (0, $l5RKy.ActionButton).PREVIOUS
    }), hasReplies && replies.map((childCommentId, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7YBvC.default), {
            key: childCommentId,
            isFirst: index === 0 && !childCommentsPageInfo?.hasNextPage,
            isLast: index === replies.length - 1 && !isReplyingToComment && !childCommentsPageInfo?.hasPreviousPage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4smaW.default), {
            commentId: childCommentId,
            fullIssueUrl: fullIssueUrl,
            isHighlighted: hasPermalink && childCommentId === permalinkId,
            commentSessionId: commentSessionId,
            isThreadedCommentsEnabled: true
        }))), childCommentsPageInfo?.hasPreviousPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xPp6.default), {
        onClickHandler: showNewerComments,
        commentId: commentId,
        type: (0, $l5RKy.ActionButton).NEXT,
        isReplyingToComment: isReplyingToComment
    }));
};
const $ed2abbb22349fd1a$export$d3607a444dfdab77 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const { fullIssueUrl: fullIssueUrl, commentSessionId: commentSessionId, commentId: commentId } = props;
    const dispatch = (0, $dyOHn.useDispatch)();
    // Optimized selectors with stable references
    const isReplyingToComment = (0, $dyOHn.useSelector)((state)=>$ed2abbb22349fd1a$var$memoizedReplyEditor(commentId, state));
    const allReplies = (0, $dyOHn.useSelector)((state)=>$ed2abbb22349fd1a$var$memoizedReplies(commentId, state));
    const childCommentsPageInfo = (0, $dyOHn.useSelector)((state)=>$ed2abbb22349fd1a$var$memoizedPagesInfo(commentId, state));
    const loadingStage = (0, $dyOHn.useSelector)((state)=>(0, $4DuXn.loadingStageSelector)(state));
    const replies = (0, $dyOHn.useSelector)((state)=>$ed2abbb22349fd1a$var$memoizedRepliesWithCollapseState(commentId, state));
    const commentCollapseInfo = (0, $dyOHn.useSelector)((state)=>$ed2abbb22349fd1a$var$memoizedCommentCollapseInfoSelector(commentId, state));
    const [collapseActionType, setCollapseActionType] = (0, $eJOHy.useState)((0, $l5RKy.CollapseActionType).INITIAL);
    const getMoreOlderComments = (0, $eJOHy.useCallback)(()=>{
        dispatch((0, $gqt7O.fetchOlderChildCommentsRequest)(commentId));
    }, [
        dispatch,
        commentId
    ]);
    const getMoreNewerComments = (0, $eJOHy.useCallback)(()=>{
        dispatch((0, $gqt7O.fetchNewerChildCommentsRequest)(commentId));
    }, [
        dispatch,
        commentId
    ]);
    const previousRepliesLength = (0, $6d9QY.usePrevious)(replies?.length);
    const previousRepliesAllLength = (0, $6d9QY.usePrevious)(allReplies?.length);
    (0, $eJOHy.useEffect)(()=>{
        if (childCommentsPageInfo) {
            const repliesLength = replies?.length;
            if (previousRepliesLength !== repliesLength && (!replies || repliesLength === 0)) {
                if (childCommentsPageInfo.hasNextPage) getMoreOlderComments();
                else if (childCommentsPageInfo.hasPreviousPage) getMoreNewerComments();
            }
        }
    }, [
        replies,
        childCommentsPageInfo,
        previousRepliesLength,
        getMoreNewerComments,
        getMoreOlderComments
    ]);
    const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $eJOHy.useMemo)(()=>$ed2abbb22349fd1a$var$getMemoizedPermalinkStatus(), []);
    // Update collapse info when replies change
    (0, $eJOHy.useEffect)(()=>{
        if (!allReplies?.length || previousRepliesAllLength === allReplies.length) return;
        const currentTopMarker = allReplies[0];
        const currentBottomMarker = allReplies[allReplies.length - 1];
        // Update top marker if we have more older comments
        if (collapseActionType === (0, $l5RKy.CollapseActionType).SHOW_MORE_OLDER) dispatch((0, $gqt7O.setCollapseInfo)({
            commentId: commentId,
            collapseActionType: collapseActionType,
            currentTopMarker: currentTopMarker
        }));
        // Update bottom marker if we have more newer comments
        if (collapseActionType === (0, $l5RKy.CollapseActionType).SHOW_MORE_NEWER) dispatch((0, $gqt7O.setCollapseInfo)({
            commentId: commentId,
            collapseActionType: collapseActionType,
            currentBottomMarker: currentBottomMarker
        }));
    }, [
        allReplies,
        previousRepliesAllLength,
        commentCollapseInfo?.currentTopMarker,
        commentCollapseInfo?.currentBottomMarker,
        dispatch,
        commentId,
        commentCollapseInfo?.collapseActionType,
        collapseActionType
    ]);
    const showOlderComments = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'showMoreReplies', {
            olderComments: true
        });
        setCollapseActionType((0, $l5RKy.CollapseActionType).SHOW_MORE_OLDER);
        if (allReplies?.length && commentCollapseInfo?.currentTopMarker !== allReplies[0]) dispatch((0, $gqt7O.setCollapseInfo)({
            commentId: commentId,
            collapseActionType: (0, $l5RKy.CollapseActionType).SHOW_MORE_OLDER,
            currentTopMarker: allReplies[0]
        }));
        else getMoreOlderComments();
    }, [
        commentCollapseInfo?.currentTopMarker,
        commentId,
        dispatch,
        getMoreOlderComments,
        allReplies
    ]);
    const showNewerComments = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'showMoreReplies', {
            newerComments: true
        });
        setCollapseActionType((0, $l5RKy.CollapseActionType).SHOW_MORE_NEWER);
        if (allReplies?.length && commentCollapseInfo?.currentBottomMarker !== allReplies[allReplies.length - 1]) dispatch((0, $gqt7O.setCollapseInfo)({
            commentId: commentId,
            collapseActionType: (0, $l5RKy.CollapseActionType).SHOW_MORE_NEWER
        }));
        else getMoreNewerComments();
    }, [
        commentCollapseInfo?.currentBottomMarker,
        commentId,
        dispatch,
        getMoreNewerComments,
        allReplies
    ]);
    const hidePreviousComments = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'showLessReplies', {
            olderComments: true
        });
        setCollapseActionType((0, $l5RKy.CollapseActionType).SHOW_LESS_OLDER);
        dispatch((0, $gqt7O.setCollapseInfo)({
            commentId: commentId,
            collapseActionType: (0, $l5RKy.CollapseActionType).SHOW_LESS_OLDER
        }));
    }, [
        commentId,
        dispatch
    ]);
    const hideNewerComments = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'showLessReplies', {
            newerComments: true
        });
        setCollapseActionType((0, $l5RKy.CollapseActionType).SHOW_LESS_NEWER);
        dispatch((0, $gqt7O.setCollapseInfo)({
            commentId: commentId,
            collapseActionType: (0, $l5RKy.CollapseActionType).SHOW_LESS_NEWER
        }));
    }, [
        commentId,
        dispatch
    ]);
    const hasReplies = replies && replies.length > 0;
    const isNewChildCommentSaving = loadingStage === `${0, $l5RKy.SAVE_CHILD_COMMENT_LOADING_PREFIX}${commentId}`;
    const isLatestChildCommentNotVisible = childCommentsPageInfo?.hasPreviousPage;
    // Memoized comment render function with optimized dependencies
    const renderComment = (0, $eJOHy.useCallback)((childCommentId, index)=>{
        // Determine if this is the last visible reply in the current view
        const isLastVisibleReply = index === (replies?.length ?? 0) - 1;
        // Check if we're not currently replying to a comment
        const isNotReplying = !isReplyingToComment;
        // Check if there are no more previous pages to load
        const hasNoPreviousPages = !childCommentsPageInfo?.hasPreviousPage;
        // Check if the current view represents the complete threaded state with collapse/expand option visible
        const isCompleteThreadState = !(childCommentsPageInfo?.hasPreviousPage || allReplies?.[allReplies.length - 1] !== replies?.[replies.length - 1] || commentCollapseInfo?.currentBottomMarker !== commentCollapseInfo?.originalBottomMarker);
        // An item is last when it's the last visible reply, we're not replying,
        // there are no previous pages, and the thread state is complete
        const isLastWithoutCollapseEnabled = isLastVisibleReply && isNotReplying && hasNoPreviousPages;
        const isLast = !(isLastWithoutCollapseEnabled && isCompleteThreadState) && (0, $epTsa.expVal)('jira_collapse_threaded_comment', 'isEnabled', false) ? false : isLastWithoutCollapseEnabled;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7YBvC.default), {
            key: childCommentId,
            isFirst: index === 0 && !childCommentsPageInfo?.hasNextPage,
            isLast: isLast
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4smaW.default), {
            commentId: childCommentId,
            fullIssueUrl: fullIssueUrl,
            isHighlighted: hasPermalink && childCommentId === permalinkId,
            commentSessionId: commentSessionId,
            isThreadedCommentsEnabled: true
        }));
    }, [
        replies,
        isReplyingToComment,
        childCommentsPageInfo?.hasPreviousPage,
        childCommentsPageInfo?.hasNextPage,
        allReplies,
        fullIssueUrl,
        hasPermalink,
        permalinkId,
        commentSessionId,
        commentCollapseInfo?.currentBottomMarker,
        commentCollapseInfo?.originalBottomMarker
    ]);
    const repliesList = (0, $eJOHy.useMemo)(()=>hasReplies && replies ? replies.map((childCommentId, index)=>renderComment(childCommentId, index)) : null, [
        hasReplies,
        replies,
        renderComment
    ]);
    // Memoized collapse container props to prevent unnecessary re-renders
    const topCollapseProps = (0, $eJOHy.useMemo)(()=>({
            commentId: commentId,
            type: (0, $l5RKy.ActionButton).PREVIOUS,
            showMoreButton: childCommentsPageInfo?.hasNextPage || allReplies?.[0] !== replies?.[0],
            onShowMoreClickHandler: showOlderComments,
            onShowLessClickHandler: hidePreviousComments,
            showLessButton: commentCollapseInfo?.currentTopMarker !== commentCollapseInfo?.originalTopMarker
        }), [
        commentId,
        childCommentsPageInfo?.hasNextPage,
        allReplies,
        replies,
        showOlderComments,
        hidePreviousComments,
        commentCollapseInfo?.currentTopMarker,
        commentCollapseInfo?.originalTopMarker
    ]);
    const bottomCollapseProps = (0, $eJOHy.useMemo)(()=>({
            commentId: commentId,
            type: (0, $l5RKy.ActionButton).NEXT,
            isReplyingToComment: isReplyingToComment,
            showMoreButton: childCommentsPageInfo?.hasPreviousPage || allReplies?.[allReplies.length - 1] !== replies?.[replies.length - 1],
            onShowMoreClickHandler: showNewerComments,
            showLessButton: commentCollapseInfo?.currentBottomMarker !== commentCollapseInfo?.originalBottomMarker,
            onShowLessClickHandler: hideNewerComments
        }), [
        commentId,
        isReplyingToComment,
        childCommentsPageInfo?.hasPreviousPage,
        allReplies,
        replies,
        showNewerComments,
        commentCollapseInfo?.currentBottomMarker,
        commentCollapseInfo?.originalBottomMarker,
        hideNewerComments
    ]);
    // Early return for empty state
    if (!repliesList || repliesList.length === 0) return null;
    // Early return for loading state
    if (isNewChildCommentSaving && isLatestChildCommentNotVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h4uO8.default), {
        onShowMoreClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onShowLessClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        commentId: commentId,
        type: (0, $l5RKy.ActionButton).PREVIOUS,
        showLessButton: false,
        showMoreButton: true,
        forceShowLoadingState: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h4uO8.default), topCollapseProps), repliesList, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h4uO8.default), bottomCollapseProps));
});
const $ed2abbb22349fd1a$var$CommentReplies = (0, $bJscI.componentWithFG)('jira_collapse_threaded_comment_gate', $ed2abbb22349fd1a$export$d3607a444dfdab77, $ed2abbb22349fd1a$export$b8b4e9ab3bc04aea);
var $ed2abbb22349fd1a$export$2e2bcd8739ae039 = $ed2abbb22349fd1a$var$CommentReplies;

});
parcelRegister("1xPp6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a63fbd2edbc11ef$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1OQKp = parcelRequire("1OQKp");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $5CSKW = parcelRequire("5CSKW");

var $284TU = parcelRequire("284TU");

var $l5RKy = parcelRequire("l5RKy");

var $4DuXn = parcelRequire("4DuXn");

var $lRq8t = parcelRequire("lRq8t");

var $7YBvC = parcelRequire("7YBvC");

var $7tzdU = parcelRequire("7tzdU");
const $9a63fbd2edbc11ef$var$ShowMoreContainer = ({ onClickHandler: onClickHandler, activeLoadingButton: activeLoadingButton, type: type, forceShowLoadingState: forceShowLoadingState, isReplyingToComment: isReplyingToComment })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7YBvC.default), {
        showNextButton: type === (0, $l5RKy.ActionButton).NEXT,
        isLast: !isReplyingToComment && type === (0, $l5RKy.ActionButton).NEXT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        xcss: $9a63fbd2edbc11ef$var$containerStyles,
        testId: "issue-view-activity-comment.comment-show-more-replies.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testId": "issue-view-activity-comment.comment-show-more-replies.empty-container",
        className: (0, $hcewu.default)([
            "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _p12f1kdh _kqswh2mm _uglpt94y _161e1v33 _1pty1eak _2knc163p _qlwi163p _631ousvi _aetrb3bt _18postnw _g0nf1yie _15l24uri _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            "_g0nfd439"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a63fbd2edbc11ef$var$buttonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onClick: (e, analyticsEvent)=>onClickHandler(analyticsEvent),
        appearance: "subtle",
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                ...iconProps,
                size: "small"
            }),
        isLoading: activeLoadingButton === type || forceShowLoadingState,
        testId: "issue-view-activity-comment.comment-show-more-replies.show-more-button"
    }, formatMessage((0, $7tzdU.messages).showMoreRepliesText)))));
};
const $9a63fbd2edbc11ef$var$containerStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});
const $9a63fbd2edbc11ef$var$buttonContainer = (0, $1DXK0.xcss)({
    position: 'absolute'
});
const $9a63fbd2edbc11ef$var$emptyContainerStyles = null;
const $9a63fbd2edbc11ef$var$customCommentStyles = null;
var $9a63fbd2edbc11ef$export$2e2bcd8739ae039 = (0, $284TU.connect)((state, ownProps)=>({
        activeLoadingButton: (0, $4DuXn.loadingMoreChildCommentsSelector)(ownProps.commentId)(state)
    }))($9a63fbd2edbc11ef$var$ShowMoreContainer);

});
parcelRegister("7tzdU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $162bb36eca094f51$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $162bb36eca094f51$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    showMoreRepliesText: {
        "id": "issue-view-activity-comment.comment-replies.show-more-replies",
        "defaultMessage": "Show more replies"
    }
});

});


parcelRegister("h4uO8", function(module, exports) {

$parcel$export(module.exports, "default", () => $de312b2b369397e0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $1OQKp = parcelRequire("1OQKp");

var $1vA1E = parcelRequire("1vA1E");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $5CSKW = parcelRequire("5CSKW");

var $284TU = parcelRequire("284TU");

var $l5RKy = parcelRequire("l5RKy");

var $4DuXn = parcelRequire("4DuXn");

var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $7YBvC = parcelRequire("7YBvC");

var $45Rm0 = parcelRequire("45Rm0");
const $de312b2b369397e0$var$CollapseRepliesContainer = ({ onShowMoreClickHandler: onShowMoreClickHandler, onShowLessClickHandler: onShowLessClickHandler = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), activeLoadingButton: activeLoadingButton, type: type, forceShowLoadingState: forceShowLoadingState, isReplyingToComment: isReplyingToComment, showLessButton: showLessButton, showMoreButton: showMoreButton })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!showMoreButton && (!showLessButton || !(0, $epTsa.expVal)('jira_collapse_threaded_comment', 'isEnabled', false))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7YBvC.default), {
        showNextButton: type === (0, $l5RKy.ActionButton).NEXT,
        isLast: !isReplyingToComment && type === (0, $l5RKy.ActionButton).NEXT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        xcss: $de312b2b369397e0$var$containerStyles,
        testId: "issue-view-activity-comment.comment-collapse-replies-container.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testId": "issue-view-activity-comment.comment-collapse-replies-container.empty-container",
        className: (0, $hcewu.default)([
            "_ca0qv47k _u5f3ze3t _n3tdv47k _19bv1b66 _p12f1kdh _kqswh2mm _uglpt94y _161e1v33 _1pty1eak _2knc163p _qlwi163p _631ousvi _aetrb3bt _18postnw _g0nf1yie _15l24uri _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            "_g0nfd439"
        ])
    }), showMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $de312b2b369397e0$var$buttonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onClick: (e, analyticsEvent)=>onShowMoreClickHandler(analyticsEvent),
        appearance: "subtle",
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                ...iconProps,
                size: "small"
            }),
        isLoading: activeLoadingButton === type || forceShowLoadingState,
        testId: "issue-view-activity-comment.comment-collapse-replies-container.show-more-button"
    }, formatMessage((0, $45Rm0.messages).showMoreRepliesText))), showLessButton && (0, $epTsa.expVal)('jira_collapse_threaded_comment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $de312b2b369397e0$var$buttonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onClick: (e, analyticsEvent)=>onShowLessClickHandler(analyticsEvent),
        appearance: "subtle",
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1vA1E))), {
                ...iconProps,
                size: "small"
            }),
        testId: "issue-view-activity-comment.comment-collapse-replies-container.show-less-button",
        isDisabled: activeLoadingButton === type || forceShowLoadingState
    }, formatMessage((0, $45Rm0.messages).showLessRepliesText)))));
};
const $de312b2b369397e0$var$containerStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});
const $de312b2b369397e0$var$buttonContainer = (0, $1DXK0.xcss)({
    position: 'relative',
    justifyContent: 'flex-end',
    gap: 'space.100'
});
const $de312b2b369397e0$var$emptyContainerStyles = null;
const $de312b2b369397e0$var$customCommentStyles = null;
var $de312b2b369397e0$export$2e2bcd8739ae039 = (0, $284TU.connect)((state, ownProps)=>({
        activeLoadingButton: (0, $4DuXn.loadingMoreChildCommentsSelector)(ownProps.commentId)(state)
    }))($de312b2b369397e0$var$CollapseRepliesContainer);

});
parcelRegister("45Rm0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $deeba058fb4dcf43$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $deeba058fb4dcf43$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    showMoreRepliesText: {
        "id": "issue-view-activity-comment.comment-collapse-replies-container.show-more-replies",
        "defaultMessage": "Show more replies"
    },
    showLessRepliesText: {
        "id": "issue-view-activity-comment.comment-replies.show-less-replies",
        "defaultMessage": "Show less replies"
    }
});

});




$parcel$global.rlb("ej9s8")
//# sourceMappingURL=async-reply-comments-list.83505c6c.js.map
